import { createContext } from 'react';

const defaultValue = {
  selectedVehicle: null,
  setSelectedVehicle: () => {},
  scheduleData: [],
  setScheduleData: () => {},
  handleMonthChange: () => {},
  start: null,
  end: null,
  recurringDayDetails: [],
  setRecurringDayDetails: () => {},
  allScheduleTypes: [],
  setAllScheduleTypes: () => {},
  allClientLocations: [],
  setAllClientLocations: () => {},
  scheduleExceptions: [],
  setScheduleExceptions: () => {},
  refreshExceptionTable: false,
  setRefreshExceptionTable: () => {},
  selectedDate: null,
  setSelectedDate: () => {},
  hasWorkplaceService: false,
  handleSelectDate: () => {},
  showExceptionsList: false,
  setShowExceptionsList: () => {},
  showExceptionsOnCalendar: true,
  setShowExceptionsOnCalendar: () => {},
  showAvailabilityOnCalendar: true,
  setShowAvailabilityOnCalendar: () => {},
  isValidToSubmit: false,
  setIsValidToSubmit: () => {},
  singleDayBooleanHasChanged: false,
  setSingleDayBooleanHasChanged: () => {},
  hasSingleDayTimeBlockError: false,
  setHasSingleDayTimeBlockError: () => {},
  recurringDayErrors: [],
  setRecurringDayErrors: () => {},
  selectedRecurringDays: [],
  setSelectedRecurringDays: () => {},
  copiedTimeBlocks: [],
  setCopiedTimeBlocks: () => {},
};

export const CalendarEditAvailabilityContext = createContext(defaultValue);
export const CalendarEditAvailabilityProvider =
  CalendarEditAvailabilityContext.Provider;
export const CalendarEditAvailabilityConsumer =
  CalendarEditAvailabilityContext.Consumer;
